// extracted by mini-css-extract-plugin
export default {"container":"employee-table_container__IOQ+9","title":"employee-table_title__WxTpN","button":"employee-table_button__LVVDT","link":"employee-table_link__8yqlN"};